export const SET_ALL_MED_DISPENSES = 'SET_ALL_MED_DISPENSES';
export const UPDATE_MED_DISPENSE = 'UPDATE_MED_DISPENSE';
export const SET_ITEM_FOR_PRINT = 'SET_ITEM_FOR_PRINT';
export const SET_INVOICE_FOR_PRINT = 'SET_INVOICE_FOR_PRINT';
export const SET_TODAYS_TODO_COUNT = 'SET_TODAYS_TODO_COUNT';
export const SET_TODAYS_TODO_COUNT_IPD = 'SET_TODAYS_TODO_COUNT_IPD';
export const SET_RAW_PHARMACY_ITEMS = 'SET_RAW_PHARMACY_ITEMS';
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export const SET_SELECTED_DISPENSE_CARDS = 'SET_SELECTED_DISPENSE_CARDS';
export const SET_TOTAL_ROWS = 'SET_TOTAL_ROWS';
